module.exports = __webpack_public_path__ + "img/qrcode.1c73d310.png";